import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'getWeekDay'
})
export class GetWeekDayPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        let convertedDays = [];

        value.forEach(days => {
            switch (days.day) {
                case 0 :
                    convertedDays.push('DOMINGO');
                    break;
                case '0' :
                    convertedDays.push('DOMINGO');
                    break;
                case 1 :
                    convertedDays.push('SEGUNDA');
                    break;
                case '1' :
                    convertedDays.push('SEGUNDA');
                    break;
                case 2 :
                    convertedDays.push('TERÇA');
                    break;
                case '2' :
                    convertedDays.push('TERÇA');
                    break;
                case 3 :
                    convertedDays.push('QUARTA');
                    break;
                case '3' :
                    convertedDays.push('QUARTA');
                    break;
                case 4 :
                    convertedDays.push('QUINTA');
                    break;
                case '4' :
                    convertedDays.push('QUINTA');
                    break;
                case 5 :
                    convertedDays.push('SEXTA');
                    break;
                case '5' :
                    convertedDays.push('SEXTA');
                    break;
                case 6 :
                    convertedDays.push('SÁBADO');
                    break;
                case '6' :
                    convertedDays.push('SÁBADO');
                    break;
            }
        });

        return convertedDays;

    }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/pipe/get-week-day.pipe.ts